import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {BehaviorSubject, Observable, distinctUntilChanged, filter, take} from 'rxjs';
import {AvailableLangs, TranslocoService} from '@ngneat/transloco';
import {FuseNavigationService, FuseVerticalNavigationComponent} from '@fuse/components/navigation';
import { GlobalState } from '../global.state';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { BreadcrumbService } from './breadcrumb.service';

export interface Breadcrumb{
    label: string;
    url: string;
    dynamic?: string;
  }

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    encapsulation: ViewEncapsulation.None,
    //changeDetection: ChangeDetectionStrategy.OnPush,
    //exportAs: 'breadcrumb'
})
export class BreadcrumbComponent {
    availableLangs: AvailableLangs;
    activeLang: string;
    flagCodes: any;
    public newPageTitle = '';
  public activePageTitle:string = '';
  public activePageTitleTop:string = '';
  breadcrumbs;
  isRefreshed=true;
  breadcrumbs$: Observable<Breadcrumb[]>;
  currentTitle ="";
  
  dynamicvalue={};
  _breadcrumbs =[];
    /**
     * Constructor
     */
    constructor(private readonly breadcrumbService: BreadcrumbService, public _state:GlobalState, public ref: ChangeDetectorRef, private activatedRoute: ActivatedRoute,
        private router: Router) {
        
        _state.subscribe('breadcrumb:title', (data) =>{
            this.currentTitle= data;
        })

        _state.subscribe('breadcrumb:dynamicvalue', (data) =>{
          //this.dynamicvalue.next({[data.key]:data.value})
          this.dynamicvalue[data.key]= data.value;
          //this.breadcrumbs$ = Observable;
          this.ngOnInit();
      })
      _state.subscribe('breadcrumb:static', (data) =>{
        //this.dynamicvalue.next({[data.key]:data.value})
        this._breadcrumbs = data;
    })
        
    }

    ngOnInit() {
      this.breadcrumbService.breadcrumbs$.subscribe(breadcrumbs => {
        this.breadcrumbs = breadcrumbs;
      })
      //this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
    }

    getDynamicValue(breadcrumb){
      //console.log('breadcrumb', breadcrumb);
      if(breadcrumb.dynamic && this.dynamicvalue[breadcrumb.dynamic]){
        return this.dynamicvalue[breadcrumb.dynamic];
      }
      return breadcrumb.label;
    }
}
